module.exports = __webpack_public_path__ + "assets/marketplace.59002833.svg";